const ProductUrlMap = {
  alA20: "album101",
  alA40: "album101",
  alB20: "album101",
  alB40: "album101",
  wpM1: "wooden_plate_square",
  wpM4: "wooden_plate_square",
  wpA1: "wooden_plate_square",
  wpA4: "wooden_plate_square",
  wpM2: "wooden_plate_rectangle",
  wpM3: "wooden_plate_rectangle",
  wpA2: "wooden_plate_rectangle",
  wpA3: "wooden_plate_rectangle",
  cb1: "wooden_plate_square",
  cb2: "wooden_plate_rectangle",
  cb3: "wooden_plate_rectangle",
  wdpM: "wooden_design_plate",
  wdpA: "wooden_design_plate",
  clK1: "calender",
  clK4: "calender",
  clK9: "calender",
  clT1: "calender",
  clT4: "calender",
  clT9: "calender",
  keyS: "keyringsquare",
  keyT: "keyringrectangle",
  plL: "printL",
  pl2L: "print2L",
  pl4: "printquartersize",
  pl8: "printquartersize",
  pc10: "postcard",
  "pc＋10": "postcard",
  ptA4: "passportpartphoto",
  NyC1: "newyearscard",
  candy: "newyearscard",
  nyc: "newyearscard",
  da1: "2side1cut",
  da2: "2side2cut",
  da3: "3side1cut",
  da3S: "3side3cut",
};
export default ProductUrlMap;
